import React from 'react';
import styled from 'styled-components';
import { Card } from 'antd';
import { PiMapPin } from 'react-icons/pi';
import type { FreePhoto_Base } from '~/common/typescript/models/FreePhoto';
import { LazyImage } from './LazyImage';
import { FreePhotoStampOverlay } from './FreePhotoStampOverlay';
import { getLocationText } from '../utils/freePhotoUtils';
import { useFreePhotoMetadata } from '../hooks/useFreePhotoMetadata';
import { useUserById } from '../hooks/useUserById';
import DateTimeViewer from '~/components/common/DateTimeViewer/DateTimeViewer';

interface FreePhotoCardProps {
  photo: FreePhoto_Base;
  onClick: () => void;
}

export const FreePhotoCard: React.FC<FreePhotoCardProps> = ({ photo, onClick }) => {
  const metadata = useFreePhotoMetadata(photo);
  const { user } = useUserById(photo.user_id);

  const locationText = getLocationText(metadata);
  const userName = user ? (user.fullname || user.username) : null;

  return (
    <UI_Card hoverable onClick={onClick} cover={
      <UI_CoverWrapper>
        <LazyImage uuid={photo.uuid} ossProcess="image/resize,w_300" alt={photo.file_name} height={200} />
        <FreePhotoStampOverlay metadata={metadata} createdAt={photo.created_at} />
      </UI_CoverWrapper>
    }>
      <Card.Meta
        title={null}
        description={
          <UI_Description>
            {/* Địa chỉ — primary, rõ */}
            <UI_Location><PiMapPin style={{ marginRight: '4px', verticalAlign: '-1px' }} />{locationText}</UI_Location>

            {/* Chụp lúc: ___ bởi ___ — secondary, nhạt */}
            <UI_Meta>
              chụp lúc:{' '}
              <DateTimeViewer
                date={photo.created_at}
                initialMode="relative"
                severity="secondary"
                showTooltip
              />
              {userName && (
                <> bởi <UI_UserName>{userName}</UI_UserName></>
              )}
            </UI_Meta>
          </UI_Description>
        }
      />
    </UI_Card>
  );
};

const UI_CoverWrapper = styled.div`
  position: relative;
  overflow: hidden;
`;

const UI_Card = styled(Card)`
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .ant-card-cover {
    overflow: hidden;
  }

  .ant-card-body {
    padding: 12px;
  }
`;



const UI_Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

const UI_Location = styled.div`
  font-size: 12px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const UI_Meta = styled.div`
  font-size: 11px;
  color: #999;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
  white-space: nowrap;
`;

const UI_UserName = styled.span`
  color: #888;
  font-weight: 500;
`;